import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Oval } from "react-loading-icons";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { TableBody, TableCell, TableRow } from "@material-ui/core";
import moment from "moment";
import { eventBus } from "../services/eventBusService";
import { DashboardHeader } from "../cmp/DashboardHeader";
import { DashboardHeadercrm } from "../cmp/DashboardHeadercrm";
import { crmService } from "../services/crmService";
import { userService } from "../services/userService";
import {
  loadUsers,
  removeUser,
  saveUser,
  keepDecaissement2,
  removeDecaissement2,
} from "../store/actions/userAction";
import { fournisseurService } from "../services/fournisseurService";
import { confirmAlert } from "react-confirm-alert"; // Import
//import "react-confirm-alert/src/react-confirm-alert.css";
import {
  loadCrms,
  removeCrm,
  saveCrm,
  keepSaisie2,
  setEditCrm,
  setEditCrmSoldCred,
  setEditCrmSoldDeb,
  setEditCrmuSoldCred,
  setEditCrmuSoldDeb,
} from "../store/actions/crmAction";
import { Modal3 } from "./Modal3";
import classnames from "classnames";
import {
  Table,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import { DashboardHeaderCollecteurDetail } from "../cmp/DashboardHeaderCollecteurDetail";
import { Modal5 } from "./Modal5CollecteurDetail";

export function GestionCollecteurDetail() {
  const dispatch = useDispatch();
  const crms = useSelector((state) => state.crmReducer.crms);
  const users = useSelector((state) => state.userReducer.users);
  const crmIdxEdited = useSelector((state) => state.crmReducer.crmIdxEdited);
  const userIdxEdited = useSelector((state) => state.userReducer.userIdxEdited);
  const loggedInUser = useSelector((state) => state.userReducer.loggedInUser);
  const [openFlag2, setOpenFlag2] = useState(false);
  const [openFlag3, setOpenFlag3] = useState(false);
  const [data, setData] = useState();
  const [data4, setData4] = useState();
  const [keyData, setKeyData] = useState();
  const [fournisseurs, setFournisseurs] = useState([]);
  const [allDecaissements, setAllDecaissements] = useState([]);
  const [allSaisies, setAllSaisies] = useState([]);
  let data3 = [];

  useEffect(() => {
    async function loadData() {
      await dispatch(loadUsers());
      await dispatch(loadCrms());

      const fournisseursFromDb = await fournisseurService.query();
      setFournisseurs(fournisseursFromDb);
      const allDecaissementsFromDb = await keepDecaissement2();
      setAllDecaissements(allDecaissementsFromDb);
      const allSaisiesFromDb = await keepSaisie2();
      setAllSaisies(allSaisiesFromDb);

      if (userIdxEdited) getDetailesByUserId();
    }

    loadData();
  }, [openFlag3]);
  const getDetailesByUserId = async () => {
    const user = await userService.getById(userIdxEdited);
    const decaissements = await keepDecaissement2({ userId: userIdxEdited });

    setData({
      ...user,
      decaissement: decaissements,
    });
  };
  function Tridata() {
    //let fournisseurs;
    allSaisies.forEach((don) => {
      if (don.destinataire_id === userIdxEdited) {
        const crm = crms.find((c) => c._id === don.crmId);

        data3.push({
          ...don,
          from: crm ? crm.firstName + " " + crm.lastName : "",
        });
      }
    });

    let dswitch = "";
    allDecaissements.map((el) => {
      if (el.userId !== userIdxEdited && el.destinataire_id === userIdxEdited) {
        const user2 = users.find((user) => user._id === el.userId);

        data3.push({
          ...el,
          credit: el.debit,
          debit: el.credit,
          from: user2 ? user2.firstName + " " + user2.lastName : "",
        });
      }
    });

    /*users.map((user3) => {
      if (user3.isAdmin) {
        fournisseurs = user3.fournisseurs;
      }
    });*/

    (data.decaissement || []).map((el, index) => {
      el.indice = index;
      fournisseurs.map((fournisseur) => {
        if (fournisseur._id === el.destinataire_id) {
          el.destinataire = fournisseur.firstName + " " + fournisseur.lastName;
        }
      });
      data3.push(el);
    });
    //console.log(data.decaissement);
    //data3.push(data.decaissement.slice());
    // console.log(data3);
    data3.sort((a, b) => {
      const first = b.dateEvent;
      const second = a.dateEvent;
      return first > second ? 1 : first < second ? -1 : 0;
    });

    /* const resd = calcDeb(data3);
    const resc = calcCred(data3);
    if (Number(resc) > Number(resd)) {
      dispatch(
        setEditCrmuSoldCred(
          (Number(resc) - Number(resd)).toFixed(2).toString(),
        ),
      );
      dispatch(setEditCrmuSoldDeb("0"));
    } else {
      dispatch(
        setEditCrmuSoldDeb((Number(resd) - Number(resc)).toFixed(2).toString()),
      );
      dispatch(setEditCrmuSoldCred("0"));
    }*/
  }
  function calcDeb(crm) {
    let res = "";
    let b = 0;
    crm.forEach((el) => {
      b = 0;
      if (!isNaN(el.debit)) b = Number(el.debit);
      res = (Number(res) + b).toFixed(2).toString();
    });
    return res;
  }
  function calcCred(crm) {
    let res = "";
    let b = 0;
    crm.forEach((el) => {
      b = 0;
      if (!isNaN(el.credit)) b = Number(el.credit);
      res = (Number(res) + b).toFixed(2).toString();
    });
    return res;
  }
  useEffect(() => {
    if (!data || !crms || !users) return;

    let dataTmp = [];
    // let fournisseurs;

    allSaisies.forEach((don) => {
      if (don.destinataire_id === userIdxEdited) {
        const crm = crms.find((c) => c._id === don.crmId);

        dataTmp.push({
          ...don,
          from: crm ? crm.firstName + " " + crm.lastName : "",
        });
      }
    });

    allDecaissements.forEach((el) => {
      if (el.userId !== userIdxEdited && el.destinataire_id === userIdxEdited) {
        const user2 = users.find((user) => user._id === el.userId);

        dataTmp.push({
          ...el,
          credit: el.debit,
          debit: el.credit,
          from: user2 ? user2.firstName + " " + user2.lastName : "",
        });
      }
    });

    /*users.forEach((user3) => {
      if (user3.isAdmin) {
        fournisseurs = user3.fournisseurs;
      }
    });*/

    (data.decaissement || []).forEach((el, index) => {
      dataTmp.push({
        ...el,
        indice: index,
        destinataire:
          fournisseurs?.find((f) => f._id === el.destinataire_id)?.firstName +
            " " +
            fournisseurs?.find((f) => f._id === el.destinataire_id)?.lastName ||
          "",
      });
    });

    const resd = calcDeb(dataTmp);
    const resc = calcCred(dataTmp);

    if (Number(resc) > Number(resd)) {
      dispatch(
        setEditCrmuSoldCred(
          (Number(resc) - Number(resd)).toFixed(2).toString(),
        ),
      );
      dispatch(setEditCrmuSoldDeb("0"));
    } else {
      dispatch(
        setEditCrmuSoldDeb((Number(resd) - Number(resc)).toFixed(2).toString()),
      );
      dispatch(setEditCrmuSoldCred("0"));
    }
  }, [
    data,
    crms,
    users,
    userIdxEdited,
    fournisseurs,
    allDecaissements,
    allSaisies,
  ]);
  useEffect(() => {
    const unsubscribe = eventBus.on("editing", () => {
      setOpenFlag2(false);
      setKeyData();
      setOpenFlag3((prev) => !prev);
    });

    return unsubscribe;
  }, []);

  /*table styleee*/
  const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  }))(TableCell);

  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

  const useStyles = makeStyles({
    table: {
      minWidth: 700,
    },
    paper: {
      elevation: 50,
    },
  });

  const classes = useStyles();

  const onDelete = (rowKey) => {
    confirmAlert({
      title: "confirmation de la suppression",
      message: "Cette action est irreversible, confirmez-vous la suppression ?",
      buttons: [
        {
          label: "Oui",
          onClick: async () => {
            const decaissementId = (data.decaissement || [])[rowKey]._id;

            await removeDecaissement2(decaissementId);

            setData((prevData) => ({
              ...prevData,
              decaissement: (prevData.decaissement || []).filter(
                (el) => el._id !== decaissementId,
              ),
            }));

            setOpenFlag3((prev) => !prev);
          },
        },
        {
          label: "Non",
          onClick: () => {},
        },
      ],
    });
  };

  const onEdit = async (rowKey) => {
    //if (crmIdxEdited == rowId) {
    // alert("Someone else is editing this row, please try later");
    //return;
    //} else {
    //console.log('redux state idx',crmIdxEdited);
    //dispatch(setEditCrm(rowId));
    //  console.log("rowkey=", rowKey);
    setKeyData(rowKey);
    setData4(data.decaissement || []);
    //console.log("data3", data3);
    //console.log("keydata =", keyData);
    setOpenFlag2(true);
    // }
  };

  const onAdd = () => {
    setData4(data.decaissement || []);
    setOpenFlag2(true);
  };

  if (!data || !loggedInUser)
    return <Oval className="oval" stroke="#06BCEE" fill="#06BCEE" />;

  //const filteredCrm = getFilteredTable();
  return (
    <div>
      {openFlag2 && <Modal5 data3={data4} keyData={keyData} />}
      <DashboardHeaderCollecteurDetail
        firstName={data.firstName}
        lastName={data.lastName}
        onAdd={onAdd}
      />

      {/* <TableContainer elevation={20} className='table-container' component={Paper}> */}
      <Table
        id="table"
        className={`table-container ${classes.table}`}
        aria-label="customized table"
      >
        <thead className="text-center">
          <tr>
            <th>Evénement</th>
            <th>date </th>

            <th> Debit (nis) </th>
            <th> Credit (nis) </th>
            <th> mode paiement </th>
            <th> destinataire / origine </th>

            {loggedInUser.isManager && <th></th>}
            {loggedInUser.isManager && <th></th>}
          </tr>
        </thead>
        <TableBody className="table-body">
          {Tridata()}
          {data3.map((don, index) => (
            <StyledTableRow key={index}>
              <StyledTableCell className="partner">{don.event}</StyledTableCell>

              <StyledTableCell className="partner">
                {moment(don.dateEvent).format("DD-MM-YY")}
              </StyledTableCell>

              <StyledTableCell className="partner">{don.debit}</StyledTableCell>

              <StyledTableCell className="partner">
                {don.credit}
              </StyledTableCell>
              <StyledTableCell className="partner">{don.mode}</StyledTableCell>
              <StyledTableCell className="partner">
                {don.from ? don.from : don.destinataire}
              </StyledTableCell>
              {!don.from && (
                <StyledTableCell className="crud-icons">
                  <i
                    onClick={() => {
                      onEdit(don.indice);
                    }}
                    className="fas fa-eye fa-lg"
                  ></i>
                </StyledTableCell>
              )}
              {!don.from && (
                <StyledTableCell className="crud-icons">
                  <i
                    onClick={() => {
                      onDelete(don.indice);
                    }}
                    className="fas fa-trash-alt fa-lg"
                  ></i>
                </StyledTableCell>
              )}
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
